module.exports = __webpack_public_path__ + "static/img/auth-bg-blue.a45c9a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auth-bg-blue.png
// module id = a5jd
// module chunks = 0